/**
 * 图片上传工具模块
 * 结合 Chating.js 和 Utils.js 的上传逻辑
 */

import Constant from '@/common/Constant';
import { genUpToken } from '@/common/QiNiYun';

// 七牛云上传配置
const UPLOAD_CONFIG = {
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
    imagePrefix: Constant.IMAGE_PREFIX || 'https://resource.fzhitong.cn/',
    bucketName: 'erpleshan', // 参考 Utils.js 中的 bucketName
    accessKey: '5BzbFPlztI2i5UeQ2irI63A15XwrvnQSeNHlEx-O',
    secretKey: 'Gf3J21KozvG7yPPPoyVTSP0JQxUFlCjneMCCp3Bq',
    uploadUrl: Constant.UPLOAD_URL || 'https://upload-z2.qiniup.com' // 默认使用华南区域
};

/**
 * 生成 UUID
 * @returns {string} UUID字符串
 */
function generateUUID() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0)
            .toString(16)
            .substring(1);
    }
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}

/**
 * 生成文件名
 * @param {string} originalName - 原始文件名
 * @returns {string} 生成的文件名
 */
export function generateFileName(originalName) {
    const uuid = generateUUID();
    const ext = originalName ? originalName.split('.').pop() : 'jpg';
    return `${uuid}.${ext}`;
}

/**
 * 获取上传 token
 * @returns {string} 上传token
 */
export function getUploadToken() {
    try {
        const policy = {
            scope: UPLOAD_CONFIG.bucketName,
            deadline: Math.round(new Date().getTime() / 1000) + 3600
        };

        const token = genUpToken(
            UPLOAD_CONFIG.accessKey,
            UPLOAD_CONFIG.secretKey,
            policy
        );

        return token;
    } catch (error) {
        console.error('生成上传token失败:', error);
        throw new Error('获取上传授权失败');
    }
}

/**
 * 验证图片文件
 * @param {File} file - 文件对象
 * @returns {Object} 验证结果 { valid: boolean, message: string }
 */
export function validateImageFile(file) {
    if (!file) {
        return { valid: false, message: '请选择要上传的图片' };
    }

    if (!UPLOAD_CONFIG.allowedTypes.includes(file.type)) {
        return {
            valid: false,
            message: '请上传正确的图片格式（JPG、PNG、GIF）'
        };
    }

    if (file.size > UPLOAD_CONFIG.maxSize) {
        return {
            valid: false,
            message: `图片大小不能超过 ${UPLOAD_CONFIG.maxSize / (1024 * 1024)}MB`
        };
    }

    return { valid: true, message: '' };
}

/**
 * 获取图片尺寸
 * @param {string} url - 图片URL
 * @returns {Promise<Object>} 图片尺寸 { width, height }
 */
export function getImageDimensions(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            resolve({
                width: img.width,
                height: img.height
            });
        };
        img.onerror = () => {
            resolve({ width: 0, height: 0 });
        };
        img.src = url;
    });
}

export default {
    generateFileName,
    getUploadToken,
    validateImageFile,
    getImageDimensions,
    uploadUrl: UPLOAD_CONFIG.uploadUrl,
    imagePrefix: UPLOAD_CONFIG.imagePrefix
};